import React, { ReactElement } from 'react';

const SVBadge = (props: any): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
      <mask
        id="mask0_3951_4485"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3951_4485)">
        <path
          d="M18.05 12L14.5 8.45L15.925 7.05L18.05 9.175L22.3 4.925L23.7 6.35L18.05 12ZM9.5 12C8.4 12 7.45833 11.6083 6.675 10.825C5.89167 10.0417 5.5 9.1 5.5 8C5.5 6.9 5.89167 5.95833 6.675 5.175C7.45833 4.39167 8.4 4 9.5 4C10.6 4 11.5417 4.39167 12.325 5.175C13.1083 5.95833 13.5 6.9 13.5 8C13.5 9.1 13.1083 10.0417 12.325 10.825C11.5417 11.6083 10.6 12 9.5 12ZM1.5 20V17.2C1.5 16.6333 1.64583 16.1125 1.9375 15.6375C2.22917 15.1625 2.61667 14.8 3.1 14.55C4.13333 14.0333 5.18333 13.6458 6.25 13.3875C7.31667 13.1292 8.4 13 9.5 13C10.6 13 11.6833 13.1292 12.75 13.3875C13.8167 13.6458 14.8667 14.0333 15.9 14.55C16.3833 14.8 16.7708 15.1625 17.0625 15.6375C17.3542 16.1125 17.5 16.6333 17.5 17.2V20H1.5Z"
          fill={props.isDarkMode ? '#fff' : '#2B8FD7'}
        />
      </g>
    </svg>
  );
};

export default SVBadge;
